// test1518
(1518 && 0);
